import { render, staticRenderFns } from "./create-api-keys.vue?vue&type=template&id=15bd7672&scoped=true&"
import script from "./create-api-keys.vue?vue&type=script&lang=ts&"
export * from "./create-api-keys.vue?vue&type=script&lang=ts&"
import style0 from "./create-api-keys.vue?vue&type=style&index=0&id=15bd7672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd7672",
  null
  
)

export default component.exports